module.exports = __webpack_public_path__ + "img/post.ec0d6d41.png";